export class MyNotificationGroupOverride {

    // Static Properties
    public static NextID = -1;

    // Server Properties
    ID: number;
    NotificationGroup_ID: number;
    NotificationEvent_ID: number;
    NotificationType_ID: number;
    User_ID: number;
    OverrideValue: boolean;
    AddedOn: Date;
    AddedBy: number;
    LastUpdatedOn: Date;
    LastUpdatedBy: number;

    // Constructor
    constructor(value?: boolean, groupId?: number, eventId?: number, typeId?: number, userId?: number) {
        this.ID = MyNotificationGroupOverride.NextID;
        MyNotificationGroupOverride.NextID -= 1;
        this.OverrideValue = value;
        if (groupId) {
            this.NotificationGroup_ID = groupId;
        }
        if (eventId) {
            this.NotificationEvent_ID = eventId;
        }
        if (typeId) {
            this.NotificationType_ID = typeId;
        }
        if (userId) {
            this.User_ID = userId;
        }
    }
}
